import { render, staticRenderFns } from "./RightsHolderWithholdingTaxes.vue?vue&type=template&id=297c0718&"
import script from "./RightsHolderWithholdingTaxes.vue?vue&type=script&lang=js&"
export * from "./RightsHolderWithholdingTaxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports